
import React from 'react';


//import { Container, Row, Col } from 'bootstrap-4-react';
import { Container, Row, Col, Spinner } from 'react-bootstrap';


// import Spinner from 'react-bootstrap/Spinner';

/*
const digestEmail = (input) => {
    const filtered = input
    .map((item) => {
      const dmarcOk = item?.dmarc?.records > 0 && item.dmarc.valid === item.dmarc.records;
      const dkimOk  = item?.dkim?.records  > 0 && item.dkim.valid  === item.dkim.records;
      const spfOk   = item?.spf?.records   > 0 && item.spf.valid   === item.spf.records;
  
      return {
        domain:             item.domain,
        "dmarc/dkim/spf":   (dmarcOk ? '✅' : '❌') + (dkimOk ? '✅' : '❌') + (spfOk ? '✅' : '❌')
      }
    })
    .filter((item) => (item["dmarc/dkim/spf"] !== '✅✅✅'));
    

    return filtered.sort((a, b) => a.domain.localeCompare(b.domain, 'en', { sensitivity: 'base' }));
};
*/

const EmailFirstStageContent = (obj) => {
    const container = {}

    container.Item   = obj.index;
    container.domain = obj.domain

    container.Url = 'https://www.'+ obj.domain;


    container.status = '';


//    const dmarcOk = item?.dmarc?.records > 0 && item.dmarc.valid === item.dmarc.records;
 //     const dkimOk  = item?.dkim?.records  > 0 && item.dkim.valid  === item.dkim.records;
//      const spfOk   = item?.spf?.records   > 0 && item.spf.valid   === item.spf.records;

   // const emptyEmail = {valid: "", records: ""};

    if (!obj.hasOwnProperty('email')) {
        // set empty row if no monitor  

       // const emptyEmail = {valid: "", records: ""};

        container.dmarc         = "";
        container.TDdmarc       = "";
        container.dkim          = "";
        container.TDdkim        = "";       
        container.spf           = "";
        container.TDspf         = "";

        container.status        = "";

    } else {



        const dmarcOk = obj?.email?.dmarc?.records > 0 && obj.email.dmarc.valid === obj.email.dmarc.records;
        const dkimOk  = obj?.email?.dkim?.records  > 0 && obj.email.dkim.valid  === obj.email.dkim.records;
        const spfOk   = obj?.email?.spf?.records   > 0 && obj.email.spf.valid   === obj.email.spf.records;
    
        const currentStatus  = (dmarcOk && dkimOk && spfOk) ? "Pass" : "Fail";

        console.debug('DEBUG', container.status, JSON.stringify(obj, null, 2));



        switch (currentStatus) {
            case "Pass":    container.status   = "Pass"; 
                            container.TDstatus = 'Blue'; 
                            break;

            case "Fail":    container.status   = "Fail"; 
                            container.TDstatus = (dmarcOk && (dkimOk || spfOk)) ? 'Amber' : 'Red';  
                            break;

            default:        container.status   = currentStatus;  
                            container.TDstatus = 'Red';
        }

        //container.dmarc         =  {valid: obj.email.dmarc.valid, records: obj.email.dmarc.records};
        //container.TDdmarc       = emptyEmail;
        
        container.dmarc         =  `${obj.email.dmarc.valid}/${obj.email.dmarc.records}`;
        container.TDdmarc       =  ((obj.email.dmarc.valid >0) && (obj.email.dmarc.valid == obj.email.dmarc.records)) ? container.TDstatus : 'Red';

        container.dkim          =  `${obj.email.dkim.valid}/${obj.email.dkim.records}`;
        container.TDdkim        =  ((obj.email.dkim.valid >0) && (obj.email.dkim.valid == obj.email.dkim.records)) ? 'Blue' : 'Red';

        container.spf           =  `${obj.email.spf.valid}/${obj.email.spf.records}`;
        container.TDspf         =  ((obj.email.spf.valid >0) && (obj.email.spf.valid == obj.email.spf.records)) ? 'Blue' : 'Red';

    /*
        if ((obj.monitor.currentStatus == "paused") || (obj.monitor.currentStatus == "n/a")) {


            const emptyTimes = ["", "", ""];

            container.uptimes       = emptyTimes;
            container.TDuptimes     = emptyTimes;
            container.durations     = emptyTimes;
            container.TDdurations   = emptyTimes;

        } else {

            container.uptimes   =   [obj.monitor.frac1d*100, obj.monitor.frac7d*100, obj.monitor.frac30d*100];
            container.TDuptimes =   [
                                        RAGuptime(obj.monitor.frac1d*100),
                                        RAGuptime(obj.monitor.frac7d*100),
                                        RAGuptime(obj.monitor.frac30d*100)
                                    ];

            
            container.TDdurations = container.TDuptimes;

            container.durations =   [
                                        obj.monitor.down1d  == 0 ? "" : secondstotime(obj.monitor.down1d), 
                                        obj.monitor.down7d  == 0 ? "" : secondstotime(obj.monitor.down7d), 
                                        obj.monitor.down30d == 0 ? "" : secondstotime(obj.monitor.down30d)
                                    ];
            }

*/
        }

    return (container);
}


// const Status = ({ data }) => {
class MonitorInformation extends React.Component {


    render() {

        if (this.props.data.length === 0) { // if no data then do nothing
            return null
        }

        //console.log(this.props.data);

        //let item = 0;
        const newdata = this.props.data;
        const firststage = newdata.map((obj) => {
 //           obj.Item = ++item;
            return EmailFirstStageContent(obj);
        })

/*
<td className={obj.TDvalid}>{(obj.dmarc.valid !== "") && obj.dmarc.valid}</td>  
<td className={obj.TDvalid}>{(obj.dmarc.records !== "") && obj.dmarc.records}</td>  
*/
        const listing = firststage.map((obj) => (
            <tr className="UptimeStatusRow" key={obj.domain}>
                <td className="number">{obj.Item}</td>
                <td className="domain"><a href={obj.Url}>{obj.domain}</a></td>
                
                <td className={obj.TDstatus}>{obj.status}</td>

                <td className={obj.TDdmarc}>{(obj.dmarc !== "") && obj.dmarc}</td>  
                <td className={obj.TDdkim}>{(obj.dkim !== "") && obj.dkim}</td>  
                <td className={obj.TDspf}>{(obj.spf !== "") && obj.spf}</td>         
            </tr>
        ))



        const output = [
            <table className="EmailStatusTable" key="UptimeStatusTable">
                <tbody>
                    <tr>
                        <th className="EmailStatusTitle">Item</th>
                        <th className="EmailStatusTitle">Site</th>

                        <th className="EmailStatusTitle">Status</th>

                        <th className="EmailStatusTitle">Dmarc</th>
       
                        <th className="EmailStatusTitle">Dkim</th>
                    

                        <th className="EmailStatusTitle">Spf</th>
                  
                    </tr >
                    {listing}
                </tbody>
            </table>
        ]

 


        return (
            <>
                {output}
            </>
        )
    }

}


class Epdemail extends React.Component {
    constructor() {
        super();
        //this.state = { data: [] };

        //this.setState = this.setState.bind(this);
    }


    render() { 


        console.log('EMAIL', this.props.state.data);

        const textStyle = {
            textAlign: "center"
        };
    

        if (this.props.state.data.length === 0) {

            return (

                <Container fluid="lg">
                    <Row>
                        <Col>
                            <h1 style={textStyle}>Email</h1>
                            <div style={textStyle}><Spinner  animation="border" /></div>
                        </Col>
                    </Row>
                </Container>
            );

        }
        else {

            return (
                <Container fluid="lg">
                    <Row>
                        <Col>
                             <h1 style={textStyle}>Email</h1>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                           <MonitorInformation data={this.props.state.data} />
                        </Col>
                    </Row>
                </Container>

            );
        }
    }
}

export {Epdemail, EmailFirstStageContent };